import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const auditLogApi = createApi({
  reducerPath: "auditLogApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["AuditLogs"],
  endpoints: (builder) => ({
    getAuditLogs: builder.query({
      query: (params) => ({ url: "/audit-logs", params }),
      providesTags: ["AuditLogs"],
    }),
    getAuditStats: builder.query({
      query: (params) => ({ url: "/audit-logs/stats", params }),
    }),
  }),
});

export const { useGetAuditLogsQuery, useGetAuditStatsQuery } = auditLogApi;
